import { lazy, Suspense, useEffect } from "react";
import { Navigate, Outlet, useLocation, useRoutes } from "react-router-dom";
import Loader from "../components/Loader/Loader";
import OfficerGuard from "../guards/OfficerGuard";
import AdminGuard from "../guards/AdminGuard";
import CustomLayout from "../components/layout/layout";
import SideLayout from "../components/layout/sideLayout";
import GuestGuard from "../guards/GuestGuard";
import { ProjectName } from "../helpers/constants";

const Loadable = (Component) => (props) => {
  return (
    <Suspense fallback={<Loader />}>
      <Component {...props} />
    </Suspense>
  );
};

const Login = Loadable(lazy(() => import("../pages/defaultPage/login")));
const NotFound = Loadable(lazy(() => import("../pages/defaultPage/notFound")));
const DistrictReports = Loadable(
  lazy(() =>
    import("../components/pageComponents/overall_reports/DistrictReports")
  )
);
const ZoneReports = Loadable(
  lazy(() => import("../components/pageComponents/overall_reports/ZoneReports"))
);
const Dashboard = Loadable(lazy(() => import("../pages/overAllDashBoard")));
const OlmmsDashboardPage = Loadable(
  lazy(() => import("../pages/olmms_dashboard"))
);
const OcmmsDashboardComponent = Loadable(
  lazy(() =>
    import("../components/pageComponents/ocmms_dashboard/ocmms_dashboard")
  )
);
const OlgprsDashboardComponent = Loadable(
  lazy(() =>
    import(
      "../components/pageComponents/olgprs_dashboard/olgprs_dashboard_componenet"
    )
  )
);
const BiomedicalDashboardComponent = Loadable(
  lazy(() => import("../pages/biomedical"))
);
const OhsDashboardComponent = Loadable(
  lazy(() => import("../pages/ohs_dashboard"))
);
const AqiDashboardComponent = Loadable(
  lazy(() => import("../pages/aqi_dashboard"))
);
const SoftwareInfo = Loadable(lazy(() => import("../pages/software_info")));
const ComingSoon = Loadable(
  lazy(() => import("../pages/defaultPage/comingSoon"))
);
const Officer = Loadable(
  lazy(() => import("../components/pageComponents/officer/Officer"))
);
const Designation = Loadable(
  lazy(() => import("../components/pageComponents/designation/designation"))
);
const District = Loadable(
  lazy(() => import("../components/pageComponents/district/District"))
);
const Taluk = Loadable(
  lazy(() => import("../components/pageComponents/Taluk/Taluk"))
);
const Dee = Loadable(
  lazy(() => import("../components/pageComponents/DEE/Dee"))
);
const FlyingSquad = Loadable(
  lazy(() => import("../components/pageComponents/FlyingSquad/FlyingSquad"))
);
const Village = Loadable(
  lazy(() => import("../components/pageComponents/villageform/village"))
);
const Zoneoffice = Loadable(
  lazy(() => import("../components/pageComponents/zoneoffice/zoneoffice"))
);
const Complaints = Loadable(
  lazy(() => import("../components/pageComponents/complaints/complaints"))
);
const User = Loadable(
  lazy(() => import("../components/pageComponents/user/User"))
);
const SoftwareInfoAdmin = Loadable(
  lazy(() =>
    import(
      "../components/pageComponents/software_info_dashboard/software_info_admin"
    )
  )
);

export default function Router() {
  const location = useLocation();

  useEffect(() => {
    const pathname = location.pathname;
    const cleanedPathname = pathname.replace(/\//, "").replace(/\/$/, "");
    const LocationName = `${cleanedPathname} | ${ProjectName}`;
    document.title = LocationName.toUpperCase();
  }, [location.pathname]);
  return useRoutes([
    {
      path: "/",
      element: (
        <GuestGuard>
          <Login />
        </GuestGuard>
      ),
    },
    {
      path: "/home",
      element: (
        <GuestGuard>
          <ComingSoon />
        </GuestGuard>
      ),
    },
    {
      path: "/about",
      element: (
        <GuestGuard>
          <ComingSoon />
        </GuestGuard>
      ),
    },
    {
      path: "/services",
      element: (
        <GuestGuard>
          <ComingSoon />
        </GuestGuard>
      ),
    },
    {
      path: "admin",
      element: (
        <AdminGuard>
          <SideLayout>
            {" "}
            <Outlet />
          </SideLayout>
        </AdminGuard>
      ),
      children: [
        {
          path: "/admin/dashboard",
          element: (
            <AdminGuard>
              <Dashboard />
            </AdminGuard>
          ),
        },
        {
          path: "/admin/olmms-dashboard",
          element: (
            <AdminGuard>
              <OlmmsDashboardPage />
            </AdminGuard>
          ),
        },
        {
          path: "/admin/ocmms-dashboard",
          element: (
            <AdminGuard>
              <OcmmsDashboardComponent />
            </AdminGuard>
          ),
        },
        {
          path: "/admin/olgprs-dashboard",
          element: (
            <AdminGuard>
              <OlgprsDashboardComponent />
            </AdminGuard>
          ),
        },
        {
          path: "/admin/biomedical-dashboard",
          element: (
            <AdminGuard>
              <BiomedicalDashboardComponent />
            </AdminGuard>
          ),
        },
        {
          path: "/admin/ohs-dashboard",
          element: (
            <AdminGuard>
              <OhsDashboardComponent />
            </AdminGuard>
          ),
        },
        {
          path: "/admin/aqi-dashboard",
          element: (
            <AdminGuard>
              <AqiDashboardComponent />
            </AdminGuard>
          ),
        },
        {
          path: "/admin/software",
          element: (
            <AdminGuard>
              <SoftwareInfo />
            </AdminGuard>
          ),
        },
        {
          path: "/admin/district-wise",
          element: (
            <AdminGuard>
              <DistrictReports />
            </AdminGuard>
          ),
        },
        {
          path: "/admin/zone-wise",
          element: (
            <AdminGuard>
              <ZoneReports />
            </AdminGuard>
          ),
        },
        {
          path: "designation",
          element: (
            <AdminGuard>
              <Designation />
            </AdminGuard>
          ),
        },
        {
          path: "officer",
          element: (
            <AdminGuard>
              <Officer />
            </AdminGuard>
          ),
        },
        {
          path: "district",
          element: (
            <AdminGuard>
              <District />
            </AdminGuard>
          ),
        },
        {
          path: "taluk",
          element: (
            <AdminGuard>
              <Taluk />
            </AdminGuard>
          ),
        },
        {
          path: "dee",
          element: (
            <AdminGuard>
              <Dee />
            </AdminGuard>
          ),
        },
        {
          path: "flying-squad",
          element: (
            <AdminGuard>
              <FlyingSquad />
            </AdminGuard>
          ),
        },
        {
          path: "village",
          element: (
            <AdminGuard>
              <Village />
            </AdminGuard>
          ),
        },
        {
          path: "zoneoffice",
          element: (
            <AdminGuard>
              <Zoneoffice />
            </AdminGuard>
          ),
        },
        {
          path: "complaints",
          element: (
            <AdminGuard>
              <Complaints />
            </AdminGuard>
          ),
        },
        {
          path: "user",
          element: (
            <AdminGuard>
              <User />
            </AdminGuard>
          ),
        },
        {
          path: "software-info",
          element: (
            <AdminGuard>
              <SoftwareInfoAdmin />
            </AdminGuard>
          ),
        },
      ],
    },
    {
      path: "officer",
      element: (
        <OfficerGuard>
          <CustomLayout>
            <Outlet />
          </CustomLayout>
        </OfficerGuard>
      ),
      children: [
        {
          path: "/officer/dashboard",
          element: (
            <OfficerGuard>
              <Dashboard />
            </OfficerGuard>
          ),
        },
        {
          path: "/officer/olmms-dashboard",
          element: (
            <OfficerGuard>
              <OlmmsDashboardPage />
            </OfficerGuard>
          ),
        },
        {
          path: "/officer/ocmms-dashboard",
          element: (
            <OfficerGuard>
              <OcmmsDashboardComponent />
            </OfficerGuard>
          ),
        },
        {
          path: "/officer/olgprs-dashboard",
          element: (
            <OfficerGuard>
              <OlgprsDashboardComponent />
            </OfficerGuard>
          ),
        },
        {
          path: "/officer/biomedical-dashboard",
          element: (
            <OfficerGuard>
              <BiomedicalDashboardComponent />
            </OfficerGuard>
          ),
        },
        {
          path: "/officer/ohs-dashboard",
          element: (
            <OfficerGuard>
              <OhsDashboardComponent />
            </OfficerGuard>
          ),
        },
        {
          path: "/officer/aqi-dashboard",
          element: (
            <OfficerGuard>
              <AqiDashboardComponent />
            </OfficerGuard>
          ),
        },
        {
          path: "/officer/software-info",
          element: (
            <OfficerGuard>
              <SoftwareInfo />
            </OfficerGuard>
          ),
        },
      ],
    },
    {
      path: "*",
      element: <Navigate to="/404" replace />,
    },
    {
      path: "404",
      element: <NotFound />,
    },
  ]);
}
